import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(() => ({
  widthAuto: {
    width: 'auto',
  },
}))
